export default function DataLoader() {
  return (
    <div className="loader_container_main">
      <i className="fa-solid fa-spinner fa-spin"></i>
    </div>
  );
}
